import { capitalizeFirstLetter, doesStartWithVowel } from 'utils/string-utils';

import { STEP_KEY } from '../utils';

import { SPECIALIST_TYPES } from './funnelConstants';

// We only support one specialist type for now, but this is stored as an array for future-proofing
const findSpecialistByIds = (ids) =>
  SPECIALIST_TYPES.find((type) => ids.includes(type.id));

const getSpecialistByIds = (specialistIds) => {
  const specialist = findSpecialistByIds(specialistIds);
  // Prefer alt title
  const specialistTitle =
    specialist?.altTitle || specialist.title || 'specialist';
  const indefiniteArticle = doesStartWithVowel(specialistTitle) ? 'an' : 'a';

  const specialistTitleWithIndefiniteArticle = `${indefiniteArticle} ${specialistTitle}`;
  const specialistTitlePlural = capitalizeFirstLetter(`${specialistTitle}s`);

  return {
    specialistTitleWithIndefiniteArticle,
    specialistTitlePlural,
    specialist,
  };
};

const getSpecialistData = (storage) => {
  const { specialistTypes = [] } = storage.get(STEP_KEY.SPECIALIST_TYPE) || {};
  const specialistIds = specialistTypes.map((type) => type.id);
  return getSpecialistByIds(specialistIds);
};

export { getSpecialistData };
